module.exports = __webpack_public_path__ + "img/dp_icon.fe28e04e.png";